import React, { PureComponent } from 'react';
import { Modal } from 'antd';
import { connect } from 'react-redux';
import { withActions } from 'actionware';
import { getTranslate } from 'react-localize-redux';

import { toggleTransactionModal, topup, withdraw } from './transactionActions';
import TransactionDetail from './transactionDetail';

@connect(({ localize, transaction: { showingTransactionModal, modalContent } }) => ({
  translate: getTranslate(localize),
  showingTransactionModal,
  modalContent
}))
@withActions({
  toggleTransactionModal,
  topup,
  withdraw
})
class TransactionModal extends PureComponent {
  constructor() {
    super();
    this.state = {};
    this.handleConfirm = this.handleConfirm.bind(this);
  };

  handleConfirm(detail) {
    const { topup, withdraw } = this.props;
    switch (detail.transactionType) {
      case 'topup':
        return topup(detail);
      case 'cashout':
        return withdraw(detail);
      default:
        break;
    };
  }
  render() {
    const { 
      showingTransactionModal,
      toggleTransactionModal,
      modalContent,
      translate
    } = this.props;
    
    return (
      <Modal
        className={'modal-form'}
        visible={showingTransactionModal}
        title={
          <div>
            <div className={'title'}>{translate('transaction.title')}</div>
            <div className={'subtitle'}>
              {translate('transaction.subtitle')}
            </div>
          </div>
        }
        onCancel={toggleTransactionModal}
        width={630}
      >
        { modalContent && <TransactionDetail
          translate={translate}
          detail={modalContent}
          onCancel={toggleTransactionModal}
          onConfirm={this.handleConfirm}
        />}
      </Modal>
    )
  }
}

export default TransactionModal;
